export default "__VITE_ASSET__BKh$qWTK__"